import { ScheduleSourceReportExport } from './ScheduleSourceReportExport';

/**
 * mutations
 *
 * @type {{ScheduleSourceReportExport: ((function({}=): Promise<*>)|*)}}
 */
export const mutations = {
  ScheduleSourceReportExport,
};
